if(document.getElementById('app_search_zone') != null){

    document.addEventListener('alpine:init', () => {

        Alpine.data('app_search_zone', (route, routeListPro) =>({
            searchinput : '',
            result : {
                'pros' : [],
                'adresses' : []
            },
            init(){
                this.route = route;
                if(routeListPro != null){
                    this.routeListPro = routeListPro;
                    //this.searchInit();
                }
                // seulement pour debug document.getElementById('modal_search_public').checked = true;
            },
            reset(){
                this.result = {
                    'pros' : [],
                    'adresses' : []
                };
            },
            searchTimeout : null,
            search(){
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    this.search_get();
                }, 300);

            },
            search_get(){
                axios.get(this.route, { params: {
                    'searchinput' : this.searchinput
                } })
                .then(response =>{
                    console.log(response.data);

                    if(response.data.length == 0){
                        return this.reset();
                    }
                    this.result = response.data;
                    this.showDefault();
                }).catch(thrown =>{

                });
            }
        }))
    })

}
